import { createAction } from "@reduxjs/toolkit";
import * as I from "core/api/coreApiClient";
import type { Notification } from "core/redux/reducers/notification/notificationReducer.types";

export function messageWithTrailingDot(message: string) {
  return message.match("[.]$") ? message : `${message}.`;
}

const notificationWithKey = (notification: Notification) => ({
  payload: {
    notification: {
      key: new Date().getTime() + Math.random(),
      ...notification,
    },
  },
});

export const clearNotification = createAction("notification/clearNotification");

export const clearedNotification = createAction("notification/clearedNotification");

export const removeNotification = createAction("notification/removeNotification", (key: number) => ({
  payload: { key },
}));

export const enqueueInfoNotification = createAction("notification/enqueueInfoNotification", (message: string) =>
  notificationWithKey({
    messages: [{ severity: I.SeverityConstants.INFO, text: messageWithTrailingDot(message) }],
  })
);

export const enqueueWarningNotification = createAction("notification/enqueueWarningNotification", (message: string) =>
  notificationWithKey({
    messages: [{ severity: I.SeverityConstants.WARN, text: messageWithTrailingDot(message) }],
  })
);

export const enqueueErrorNotification = createAction("notification/enqueueErrorNotification", (message: string) =>
  notificationWithKey({
    messages: [{ severity: I.SeverityConstants.ERROR, text: messageWithTrailingDot(message) }],
  })
);

/**
 * Only used for messages returned by the backend to show one or a stack of messages
 */
export const enqueueMessage = createAction("notification/enqueueMessage", (messages: I.Message[]) =>
  notificationWithKey({
    messages,
  })
);
